import React from 'react'
import TasksTemplateCN from '../contentPages/TasksTemplateCN'

const Tasks = () => {
	return <TasksTemplateCN />
}

export default Tasks
